// src/components/SongsBrowser/SongsBrowser.jsx
import React, { useState, useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import SectionWrapper from "../SectionWrapper/SectionWrapper";
import songsJson from "../../data/songs.json";
import ohjelmistoImage from "../../assets/esiintymiset_image.webp";

const categories = ["kotimainen", "ulkomainen", "tanssimusiikki"];

const SongsBrowser = () => {
  useEffect(() => {
    AOS.init({});
  }, []);

  const { kotimainen, ulkomainen, tanssimusiikki } = songsJson.ohjelmisto;
  const [activeCategory, setActiveCategory] = useState("kotimainen");
  const [searchTerm, setSearchTerm] = useState("");
  const [showList, setShowList] = useState(false);

  const list =
    activeCategory === "kotimainen"
      ? kotimainen
      : activeCategory === "ulkomainen"
      ? ulkomainen
      : tanssimusiikki;

  const filteredSongs = list.filter(
    ({ title, artist }) =>
      title.toLowerCase().includes(searchTerm.toLowerCase()) ||
      artist.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <>
      <SectionWrapper id="ohjelmisto" aria-labelledby="ohjelmisto-heading" role="region">
        <div className="flex flex-col md:flex-row items-start" data-aos="fade-in">
          <img
            src={ohjelmistoImage}
            alt="Bilebändi Joyriden ohjelmisto"
            className="w-32 h-32 md:w-48 md:h-48 rounded-lg object-cover mb-6 md:mb-0 md:mr-6 flex-shrink-0"
            data-aos="fade-right"
          />

          <div className="flex-1">
            <h2
              id="ohjelmisto-heading"
              className="text-4xl font-bold font-lobster text-joyridePurple dark:text-joyrideCyan mb-4 text-right dark:text-shadow-lg"
              data-aos="fade-down"
            >
              Bilebändi Joyriden ohjelmisto
            </h2>
            <p
              className="text-joyrideNavy text-lg font-light dark:text-joyrideLight mb-8"
              data-aos="fade-up"
            >
              Tutustu Bilebändi Joyriden monipuoliseen ohjelmistoon! Voit selata eri kategorioita, hakea kappaleita tai artisteja
              nimellä ja avata YouTube-linkin kuunnellaksesi kappaleen. Listan voit näyttää tai piilottaa halutessasi.
            </p>

            <div className="flex flex-wrap gap-2 mb-6" data-aos="fade-up">
              {categories.map((cat) => (
                <button
                  key={cat}
                  onClick={() => setActiveCategory(cat)}
                  aria-label={`Näytä ${cat}-kategorian kappaleet`}
                  className={`px-3 py-1 rounded-full text-sm font-medium transition-all duration-200 transform hover:scale-105 hover:shadow-lg ${
                    activeCategory === cat
                      ? "bg-joyridePurple text-joyrideLight"
                      : "bg-joyrideSky text-joyrideNavy dark:bg-joyridePurple dark:text-joyrideLight hover:bg-joyridePurple hover:text-joyrideLight"
                  }`}
                >
                  {cat.charAt(0).toUpperCase() + cat.slice(1)}
                </button>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row gap-2 mb-8" data-aos="fade-up">
              <input
                type="text"
                placeholder="Hae Bilebändi Joyriden ohjelmistosta artistia tai kappaletta..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                aria-label="Hae artistia tai kappaletta Bilebändi Joyriden ohjelmistosta"
                className="flex-1 px-3 py-1 border-joyridePurple rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-joyrideCyan"
              />

              <button
                onClick={() => setShowList((v) => !v)}
                aria-label={showList ? "Piilota kappalelista" : "Näytä kappalelista"}
                className="px-3 py-1 rounded-lg text-sm font-medium bg-joyridePurple text-joyrideLight hover:bg-joyridePurple dark:hover:bg-joyrideCyan dark:hover:text-joyrideNavy hover:text-joyrideLight transition-all duration-200 transform hover:scale-105 hover:shadow-lg"
              >
                {showList ? "Piilota lista" : "Näytä lista"}
              </button>
            </div>

            {(showList || searchTerm) && (
              <div
                className="h-64 overflow-y-scroll border-2 border-joyridePurple rounded-lg p-4 bg-joyrideLight dark:bg-joyrideNavy relative"
                data-aos="fade-up"
              >
                <ul className="space-y-4">
                  {filteredSongs.length > 0 ? (
                    filteredSongs.map((song, idx) => (
                      <li
                        key={idx}
                        className="p-2 rounded-lg hover:bg-joyrideSky dark:hover:bg-joyrideBars transition-colors"
                      >
                        <strong className="block text-joyridePurple dark:text-joyrideCyan text-base">
                          {song.title}
                        </strong>
                        <span className="block text-joyrideNavy dark:text-joyrideLight mb-1 text-sm">
                          {song.artist}
                        </span>
                        <a
                          href={song.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="inline-block text-xs text-joyridePurple dark:text-joyrideCyan underline hover:opacity-80"
                        >
                          Katso YouTubessa!
                        </a>
                      </li>
                    ))
                  ) : (
                    <li className="text-center text-joyrideNavy dark:text-joyrideLight">
                      Ei osumia haulle.
                    </li>
                  )}
                </ul>
              </div>
            )}
          </div>
        </div>
      </SectionWrapper>
    </>
  );
};

export default SongsBrowser;
